import axios from 'axios';
import { getApiHeader } from './../services/getApiHeaders';

export function getShipments(payload) {
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/shipment/search',
        headers: getApiHeader(),
        data: payload,
        withCredentials: true,
    }

    return axios(options)
}

export function addPackageInfo(payload) {
    return axios({
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/shipment/updatepackageinfor',
        headers: getApiHeader(),
        data: payload,
        withCredentials: true,
    })
}

export function deleteShipment(payload) {
    return axios({
        method: 'DELETE',
        url: process.env.REACT_APP_URL + '/api/shipment/delete',
        headers: getApiHeader(),
        data: payload,
        withCredentials: true,
    })
}

export function clearShipmentFailFeeds(payload) {
    return axios({
        method: 'PUT',
        url: process.env.REACT_APP_URL + '/api/shipment/feed',
        headers: getApiHeader(),
        data: payload,
        withCredentials: true
    })
}

export function toTransmited(payload) {
    return axios({
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/shipment/updatestatus',
        headers: getApiHeader(),
        data: payload,
        withCredentials: true,
    })
}
export function getLabelsInfo(payload) {
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/shipment/print',
        headers: getApiHeader(),
        responseType: 'blob',
        data: payload,
        withCredentials: true,
    }
    return axios(options)
}
export function getShipmentById(shipment_id) {
    return axios({
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/shipment/' + shipment_id,
        headers: getApiHeader(),
        withCredentials: true,
    })
}

export function getPackageInfoById(payload) {
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/shipment/getpackageinforbyids',
        headers: getApiHeader(),
        data: payload,
        withCredentials: true,
    }
    return axios(options)
}

export function getPackageInfoByShipmentId(payload) {
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/shipment/getpackagesbyshipmentids',
        headers: getApiHeader(),
        data: payload,
        withCredentials: true,
    }
    return axios(options)
}

export function printTest(labelType) {
    return axios({
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/printer/gettestinglabel?paperSize=' + labelType,
        headers: getApiHeader(),
        responseType: 'blob',
        withCredentials: true,
    })
}

export function getExportShipmentData(params) {
    return axios({
        method: 'POST',
        url: `${process.env.REACT_APP_URL}/api/shipment/export/feed`,
        headers: getApiHeader(),
        data: params,
        withCredentials: true,
    })
}

export function getFileFormatExportShipment() {
    return axios({
        method: 'GET',
        url: `${process.env.REACT_APP_URL}/api/shipment/export/mapping`,
        headers: getApiHeader(),
        withCredentials: true,
    })
}



// WEBPACK FOOTER //
// ./src/utils/shipment.js